import BaseService from '../base';

class HealthCareProvider extends BaseService {}

export default new HealthCareProvider('health-care-providers', 'HealthCareProvider');
